import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import AntResult from 'antd/es/result';
import dayjs from 'dayjs';

function SaleImportingMaintenance({ result = {} }) {
  return (
    <div className="flex h-screen w-screen">
      <AntResult
        icon={
          <DotLottieReact
            src="assets/jsons/data-management.lottie"
            loop
            autoplay
            mode="bounce"
          />
        }
        title="Hệ thống đang cập nhật dữ liệu mới"
        subTitle={
          <div>
            Vui lòng đợi trong giây lát hoặc sử dụng chức năng khác!
            {!!result?.est_time && (
              <div>
                Thời gian hoàn thành dự kiến:{' '}
                <code>{dayjs.unix(result?.est_time).format('HH[h]mm')}</code>
              </div>
            )}
          </div>
        }
        className="m-auto pointer-events-none"
      />
    </div>
  );
}

export default SaleImportingMaintenance;
